/* =====================================================================
   LUX Product Page — scoped JS
   - Variant picker (chip-based) wired to Shopify product form
   - Quantity stepper
   - Hero gallery thumb switching
   - Hero tabs (See in action / See fit transformation)
   - Announcement bar rotator
   - FAQ + details accordions (keyboard accessible)
   - Sticky mobile ATC mirrors current variant
   - Cart submit: attempts AJAX (/cart/add.js) and dispatches a
     CustomEvent('lux:cart:added') the host theme can listen for; falls
     back to a normal form submit if AJAX is unavailable.
   ===================================================================== */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------- Announce bar rotator ---------------- */
  function initAnnounce() {
    $$('[data-lux-announce]').forEach(function (bar) {
      var items = $$('.lux-announce__item', bar);
      if (items.length < 2) return;
      var speed = parseInt(bar.getAttribute('data-rotate-speed') || '3200', 10);
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------------- Tabs ---------------- */
  function initTabs() {
    $$('[data-lux-tabs]').forEach(function (tabs) {
      var buttons = $$('[data-lux-tab]', tabs);
      var panels  = $$('[data-lux-tab-panel]', tabs);
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-lux-tab');
          buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) {
            var match = p.getAttribute('data-lux-tab-panel') === key;
            p.hidden = !match;
            p.classList.toggle('is-active', match);
          });
        });
      });
    });
  }

  /* ---------------- Gallery thumbs ---------------- */
  function initGallery() {
    $$('[data-lux-gallery]').forEach(function (gallery) {
      var main = $('[data-lux-gallery-main]', gallery);
      if (!main) return;
      var thumbs = $$('[data-lux-gallery-thumb]', gallery);
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          if (src) {
            main.src = src;
            main.alt = alt;
          }
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });
    });
  }

  /* ---------------- Accordions (FAQ + Details) ---------------- */
  function initAccordions() {
    $$('[data-lux-accordion]').forEach(function (group) {
      var items = $$('[data-lux-accordion-item]', group);
      items.forEach(function (item) {
        var btn = $('[data-lux-accordion-trigger]', item);
        if (!btn) return;
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function () {
          var open = item.getAttribute('aria-expanded') === 'true';
          if (group.hasAttribute('data-lux-accordion-single')) {
            items.forEach(function (i2) {
              i2.setAttribute('aria-expanded', 'false');
              var b2 = $('[data-lux-accordion-trigger]', i2);
              if (b2) b2.setAttribute('aria-expanded', 'false');
            });
          }
          var next = !open;
          item.setAttribute('aria-expanded', next ? 'true' : 'false');
          btn.setAttribute('aria-expanded', next ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------------- Quantity stepper ---------------- */
  function initQuantity(root) {
    $$('[data-lux-qty]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = $('[data-lux-qty-input]', root);
        if (!input) return;
        var delta = parseInt(btn.getAttribute('data-lux-qty'), 10);
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var next = (parseInt(input.value, 10) || min) + delta;
        if (next < min) next = min;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------------- Variant picker ---------------- */
  function initVariantPicker(form) {
    var dataEl = $('[data-lux-variant-data]', form);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionButtons = $$('[data-lux-option-button]', form);
    var idInput = $('[data-lux-variant-id]', form);
    var selected = [];

    // Read currently-active options
    $$('[data-lux-option-index]', form).forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-lux-option-index'), 10);
      if (isNaN(idx)) return;
      var active = $('.lux-size-chip--active', group);
      selected[idx] = active ? active.getAttribute('data-lux-option-value') : null;
    });

    function findVariant() {
      return variants.find(function (v) {
        for (var i = 0; i < selected.length; i++) {
          if (v.options[i] !== selected[i]) return false;
        }
        return true;
      });
    }

    function moneyFormat(cents) {
      // Shopify exposes window.Shopify.currency / theme money filter — fallback to simple
      try {
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents, (window.theme && window.theme.moneyFormat) || '${{amount}}');
        }
      } catch (e) {}
      return '$' + (cents / 100).toFixed(2);
    }

    function refresh() {
      var v = findVariant();
      var atc = $('[data-lux-atc]', form);
      var priceEl = $('[data-lux-price]', form.closest('[data-lux-purchase]') || form);
      var comparePriceEl = $('[data-lux-compare-price]', form.closest('[data-lux-purchase]') || form);
      var saveBadgeEl = $('[data-lux-save-badge]', form.closest('[data-lux-purchase]') || form);
      var ctaPrice = $('[data-lux-cta-price]', form);
      var ctaLabel = $('[data-lux-cta-label]', form);

      if (!v) {
        if (atc) {
          atc.setAttribute('disabled', 'disabled');
          if (ctaLabel) ctaLabel.textContent = 'Unavailable';
        }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = moneyFormat(v.price);
      if (comparePriceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          comparePriceEl.textContent = moneyFormat(v.compare_at_price);
          comparePriceEl.style.display = '';
          if (saveBadgeEl) {
            saveBadgeEl.textContent = 'Save ' + moneyFormat(v.compare_at_price - v.price);
            saveBadgeEl.style.display = '';
          }
        } else {
          comparePriceEl.style.display = 'none';
          if (saveBadgeEl) saveBadgeEl.style.display = 'none';
        }
      }
      if (atc) {
        if (v.available) {
          atc.removeAttribute('disabled');
          atc.removeAttribute('aria-disabled');
        } else {
          atc.setAttribute('disabled', 'disabled');
          atc.setAttribute('aria-disabled', 'true');
        }
        if (ctaLabel) {
          ctaLabel.innerHTML = v.available
            ? (atc.getAttribute('data-lux-label') || 'Add to Cart') + (ctaPrice ? ' — <span data-lux-cta-price>' + moneyFormat(v.price) + '</span>' : '')
            : 'Sold Out';
        }
      }

      // Mirror to all sticky bars and final CTAs
      document.dispatchEvent(new CustomEvent('lux:variant:changed', { detail: { variant: v, productHandle: form.getAttribute('data-product-handle') } }));
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-lux-option-index'), 10);
        var val = btn.getAttribute('data-lux-option-value');
        if (isNaN(idx)) return;
        // Update active state within this option group
        $$('[data-lux-option-button][data-lux-option-index="' + idx + '"]', form).forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('lux-size-chip--active', active);
          b.setAttribute('aria-checked', active ? 'true' : 'false');
        });
        // Mirror the label
        var group = btn.closest('[data-lux-option-index]');
        var label = group ? $('.lux-selected-value', group) : null;
        if (label) label.textContent = val;
        selected[idx] = val;
        refresh();
      });
    });

    refresh();
  }

  /* ---------------- Sticky mobile ATC mirror ---------------- */
  function initStickyMirror() {
    document.addEventListener('lux:variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      var handle = e.detail.productHandle;
      $$('[data-lux-sticky]').forEach(function (sticky) {
        if (handle && sticky.getAttribute('data-product-handle') && sticky.getAttribute('data-product-handle') !== handle) return;
        var idInput = $('[data-lux-variant-id]', sticky);
        if (idInput) idInput.value = v.id;
        var price = $('[data-lux-price]', sticky);
        if (price) {
          try {
            price.textContent = (window.Shopify && window.Shopify.formatMoney)
              ? window.Shopify.formatMoney(v.price, (window.theme && window.theme.moneyFormat) || '${{amount}}')
              : '$' + (v.price / 100).toFixed(2);
          } catch (err) {}
        }
        var btn = $('[data-lux-atc]', sticky);
        if (btn) {
          if (v.available) btn.removeAttribute('disabled');
          else btn.setAttribute('disabled', 'disabled');
        }
      });
    });
  }

  /* ---------------- AJAX cart submit (graceful fallback) ---------------- */
  function initCartSubmit() {
    $$('[data-lux-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // let native form submit
        // Honour theme's existing cart implementation if it already wires this form
        if (form.getAttribute('data-lux-bypass-ajax') === 'true') return;

        e.preventDefault();
        var atc = $('[data-lux-atc]', form);
        if (atc) atc.setAttribute('disabled', 'disabled');

        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        })
          .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
          .then(function (res) {
            if (!res.ok) throw res.body;
            // notify any theme cart drawer
            document.dispatchEvent(new CustomEvent('lux:cart:added', { detail: res.body }));
            // also dispatch a generic cart:refresh event many themes listen for
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.dispatchEvent(new CustomEvent('cart:refresh'));
            // best-effort: open theme cart drawer if available
            var drawerToggle = document.querySelector('[data-cart-drawer-toggle], cart-drawer button[aria-controls]');
            if (drawerToggle) drawerToggle.click();
          })
          .catch(function (err) {
            console.warn('[lux] AJAX add failed, falling back to native submit', err);
            form.setAttribute('data-lux-bypass-ajax', 'true');
            form.submit();
          })
          .then(function () {
            if (atc) atc.removeAttribute('disabled');
          });
      });
    });
  }

  function boot() {
    initAnnounce();
    initTabs();
    initGallery();
    initAccordions();
    $$('[data-lux-purchase]').forEach(function (purchase) {
      initQuantity(purchase);
      var form = $('[data-lux-form]', purchase);
      if (form) initVariantPicker(form);
    });
    initStickyMirror();
    initCartSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
